import "../css/FullCustomHtml.css.css"
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Flex } from "antd";
import sanitizeHtml from 'sanitize-html';
import { getFromLocalStorage, saveToLocalStorage } from "../utils/localStorage";
import { useQuery } from "@apollo/client";
import { GET_FORM_SECTION_BY_SLUG } from "../queries";
import {
  populateGclid,
  populateUtmSource,
  populateUtmMedium,
  populateUtmCampaign,
  populateUtmTerm,
  populateUtmContent,
} from "../utils/utmHelpers";
import getFullLanguage from "utils/getFullLanguage";
import { inputs } from "../langs/contactForm";

const validPersonalEmail = (email, lang) => {
  const personalDomains = [
    "gmail.com",
    "yahoo.com",
    "outlook.com",
    "hotmail.com",
    "aol.com",
    "icloud.com",
  ];

  const emailDomain = email.split("@")[1];
  if (personalDomains.includes(emailDomain)) {
    return true;
  }
}

const FullCustomHtml = ({ page, section, lang }) => {
  const slug = `${page}-${section}-${lang}`;
  const navigate = useNavigate();

  const [sectionData, setSectionData] = useState(() => {
    const cachedData = getFromLocalStorage(page);
    return cachedData?.sections?.[slug] || null;
  });

  const { loading, error, data } = useQuery(GET_FORM_SECTION_BY_SLUG, {
    variables: { slug },
    skip: !!sectionData,
    onCompleted: (fetchedData) => {
      const postData = fetchedData.sectionsBy?.htmlPersonalizado;
      const dataToLocal = {
        ...sectionData,
        sections: {
          [slug]: postData,
        },
      };
      saveToLocalStorage(page, dataToLocal);
      setSectionData(postData);
    },
  });

  useEffect(() => {
    const form = document.querySelector(".FullCustomHtml-content form");
    if (!form) return;



    const clearErrors = (form) => {
      form.querySelectorAll(".form-error-message").forEach((el) => el.remove());
    };

    const handleSubmit = async (e) => {
      e.preventDefault();
      console.log("Formulario enviado");
      console.log("Datos del formulario:", e.target);

      const formData = new FormData(form);
      const data = Object.fromEntries(formData.entries());
      data["00N7R00000H84xL"] = getFullLanguage(lang);
      data["00N7R00000H84xV"] = populateUtmCampaign();
      data["00N7R00000H84xW"] = populateUtmContent();
      data["00N7R00000H84xX"] = populateUtmMedium();
      data["00N7R00000H84xY"] = populateUtmSource();
      data["00N7R00000H84xZ"] = populateUtmTerm();
      data["00N7R00000G8jxv"] = populateGclid();

      const requestOptions = {
        method: 'POST',
        mode: 'no-cors',
      };

      clearErrors(form);

      let hasError = false;
      
      const fields = [
        { id: "first_name", label: inputs[lang].fieldName.epmtyRule },
        { id: "last_name", label: inputs[lang].fieldLastname.epmtyRule },
        { id: "email", label: inputs[lang].fieldEmail.validRule },
        { id: "industry", label: inputs[lang].fieldIndustry.emptyRule },
        { id: "country_code", label: inputs[lang].fieldCountry.emptyRule },
        { id: "url", label: inputs[lang].fieldWebCorporative.emptyRule }
      ];

      fields.forEach(({ id, label }) => {

        const input = form.querySelector(`#${id}`);
        if (input){

          const value = input?.value.trim(); //Despues de ? no es necesario, pero es una buena práctica para evitar errores si el input no existe.

          const isInvalid = !value || (id === "email" && validPersonalEmail(value, lang));
          if (isInvalid) {
            hasError = true;

            const error = document.createElement("div");
            error.className = "form-error-message";
            error.style.color = "red";
            error.style.fontSize = "13px";
            error.style.marginTop = "4px";
            error.innerText = label;

            const wrapper = input.closest(".field-partnership") || input.parentElement;
            if (wrapper && !wrapper.querySelector(".form-error-message")) {
              wrapper.appendChild(error);
            }
          }

        };
        
      });

      const checkbox = form.querySelector("#heleido");
      if (!checkbox?.checked) {
        hasError = true;

        const error = document.createElement("div");
        error.className = "form-error-message";
        error.style.color = "red";
        error.style.fontSize = "13px";
        error.style.marginTop = "4px";
        error.innerText = inputs[lang].fieldPrivacy.emptyRule;

        const wrapper = checkbox.closest(".ant-form-item-control-input-content") || checkbox.parentElement;
        if (wrapper && !wrapper.querySelector(".form-error-message")) {
          wrapper.appendChild(error);
        }
      }

      if (hasError) return;

      const sanitized = {};
      Object.entries(data).forEach(([k, v]) => {
        if (v != null) {
        sanitized[k] = sanitizeHtml(String(v));
        }
      });
      
      const params = new URLSearchParams();
      Object.entries(sanitized).forEach(([k, v]) => {
        params.append(k, v);
      });
	  
		  const queryString = params.toString();
      const url = `https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8&oid=00D7R000005HP0B&${queryString}`;

      const response = await fetch(url, requestOptions)
        .then((response) => response)
        .then((result) => console.log(result))
        .catch((error) => console.log('error', error));

      console.log("Formulario enviado con éxito:");
      navigate(`${data["retURL"]}`, { replace: true });


      console.log("Datos del formulario:", { data });
    };

    form.addEventListener("submit", handleSubmit);

    return () => {
      form.removeEventListener("submit", handleSubmit);
    };
  }, [sectionData]);

  return (
    <Flex className="FullCustomHtml">
      <div
        style={{ lineHeight: '120%' }}
        className="b4-body-400 FullCustomHtml-content"
        dangerouslySetInnerHTML={{ __html: sectionData?.htmlContent }}
      />
    </Flex>
  );
};

export default FullCustomHtml;
